import { Link } from "react-router-dom";
import "./App.css";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const tags = [
    {
      name: t('footer.quickLinks'),
      links: [
        {
          name: t('footer.links.home'),
          href: "/",
        },
        {
          name: t('footer.links.about'),
          href: "/sobre-nosotros",
        },
        {
          name: t('footer.links.machinery'),
          href: "/maquinaria",
        },
        { name: t('footer.links.quality'), href: "/sistema-de-calidad" },
        {
          name: t('footer.links.products'),
          href: "/productos",
        },
        {
          name: t('footer.links.blog'),
          href: "/blog",
        },
      ],
    },
    {
      name: t('footer.security'),
      links: [
        {
          name: t('footer.terms'),
        },
        {
          name: t('footer.privacy'),
          href: "/assets/docs/privacy-policies.pdf",
        },
        {
          name: t('footer.country'),
        },
      ],
    },
    {
      name: t('footer.contact'),
      links: [
        {
          name: t('common.phone1'),
        },
        {
          name: t('common.phone2'),
        },
        {
          href: "mailto:ventas@sisacero.com",
          name: t('common.email'),
        },
        {
          name: t('common.address'),
        },
      ],
    },
  ];
  return (
    <footer className="mx-auto px-8 md:px-28 relative w-full bg-[#192457] overflow-hidden">
      <div
        className="hidden md:block absolute inset-0 bg-no-repeat bg-[length:700px_auto] bg-[position:left_190px] opacity-[3%] pointer-events-none z-0"
        style={{ backgroundImage: "url('/assets/img/footer.png')" }}
        aria-hidden="true"
      />
      <div className="relative z-10 md:py-[50px] pt-16">
        <p className="font-semibold text-[19px] text-white">
          <img
            src="/assets/svg/logo-white.svg"
            alt="logo"
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </p>
        <div className="flex justify-end md:mt-0 mt-16 ">
          <div className="w-3/4 hidden md:block" />
          <div className="md:flex justify-start md:space-x-8 w-full">
            {tags.map((tag) => (
              <div className="w-[205px]" key={tag.name}>
                <p className="font-semibold text-left text-lg text-white uppercase">
                  {tag.name}
                </p>
                <div className="flex flex-col space-y-2 my-8">
                  {tag.links.map((link: any) =>
                    link?.href ? (
                      <div className="flex items-center space-x-2">
                        {link.href.endsWith(".pdf") ? (
                          <a
                            className="text-left text-white text-base hover:text-gray-300 transition-colors"
                            key={link.name}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link.name}
                          </a>
                        ) : (
                          <Link
                            className="text-left text-white text-base hover:text-gray-300 transition-colors"
                            key={link.name}
                            to={link?.href}
                            onClick={() => {
                              tag.name === "Recursos" && scrollToTop();
                            }}
                          >
                            {link.name}
                          </Link>
                        )}
                      </div>
                    ) : (
                      <div className="flex items-center space-x-2">
                        <span
                          className="text-left text-white text-base"
                          key={link.name}
                        >
                          {link.name}
                        </span>
                      </div>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="md:absolute bottom-8 left-8 space-y-4 mb-16 md:mb-0">
        <img
          src="/assets/img/iso9001.png"
          alt="footer-logo"
          loading="lazy"
          decoding="async"
        />
        <div className="flex items-center space-x-2">
          <img
            src="/assets/img/logo_foot.png"
            alt="footer-logo"
            loading="lazy"
            decoding="async"
          />
          <p className="text-white text-xs text-left">
            {t('footer.copyright')}
          </p>
        </div>
      </div>

      {/* Alluxi Credit */}
      <div className="relative z-10 pb-6 text-center">
        <p className="text-white/40 text-sm">
          {t('footer.developedBy')}{" "}
          <a
            href="https://alluxi.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/60 hover:text-white/80 transition-colors duration-200"
          >
            Alluxi
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
